module.exports = __webpack_public_path__ + "assets/img/banner.7e6b6d58.png";